import React from 'react';
import styles from './StudyHeader.module.css';

const StudyHeader = ({ title, onBack, children, className = '' }) => {
  return (
    <div className={`${styles.header} ${className}`}>
      <button
        type="button"
        className={styles.backButton}
        onClick={onBack}
        aria-label="返回"
      >
        <span className={`material-symbols-outlined ${styles.backIcon}`}>arrow_back</span>
      </button>
      {title && <h1 className={styles.title}>{title}</h1>}
      {children}
    </div>
  );
};

export default StudyHeader;

